import API from '../config';

const base = `${API.BASE_DEV_HOST}/api`;
const userBaseUrl = `${base}/user`;

export const getUsers = () => `${base}/users`;
export const create = () => `${base}/profiles/`;
export const savePermissions = () => `${base}/users/permissions`;
export const userPermissions = (userId: number, firmId?: number) =>
  `${userBaseUrl}/${userId}/permissions/${firmId ?? ''}`;
export const firmUserPermissions = (firmId: number) => `${base}/users/firm_users/${firmId}`;
export const lowerUserPermissions = (userId: number) => `${userBaseUrl}/${userId}/lower-permissions`;
export const userProfileById = (userId: number) => `${base}/profiles/${userId}`;
export const updateUserProfile = (userId: number) => `${base}/profiles/${userId}`;
export const deleteUser = (userId: string) => `${userBaseUrl}/${userId}/delete`;
export const createBulkUsers = () => `${base}/users/create-bulk-users`;
export const deleteCompanyUserPermissions = (userId: number, companyId: number) =>
  `${base}/users/permissions/${userId}/${companyId}`;

export default getUsers;
